import React from 'react';
import MockReadinessChart from './MockReadinessChart';

interface MockDashboardPreviewProps {
    variant?: 'full' | 'icon';
    className?: string;
}

const stats = [
    { label: 'Readiness', value: '82%', color: '#22C55E' },
    { label: 'HRV', value: '68ms', color: '#3B82F6' },
    { label: 'Sleep', value: '7.2h', color: '#8B5CF6' },
    { label: 'ACWR', value: '1.1', color: '#EAB308' },
];

const MockDashboardPreview: React.FC<MockDashboardPreviewProps> = ({ variant = 'full', className = '' }) => {
    if (variant === 'icon') {
        return (
            <div className={`w-full max-w-[120px] ${className}`}>
                <svg viewBox="0 0 80 60" className="w-full h-auto" fill="none">
                    {/* Mini dashboard icon */}
                    <rect x="1" y="1" width="78" height="58" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
                    {/* Header bar */}
                    <rect x="1" y="1" width="78" height="10" fill="rgba(255,255,255,0.06)" />
                    <circle cx="8" cy="6" r="2" fill="rgba(255,255,255,0.2)" />
                    <circle cx="14" cy="6" r="2" fill="rgba(255,255,255,0.2)" />
                    {/* Stat cards */}
                    <rect x="5" y="15" width="16" height="10" stroke="rgba(255,255,255,0.15)" strokeWidth="0.5" />
                    <rect x="23" y="15" width="16" height="10" stroke="rgba(255,255,255,0.15)" strokeWidth="0.5" />
                    <rect x="41" y="15" width="16" height="10" stroke="rgba(255,255,255,0.15)" strokeWidth="0.5" />
                    <rect x="59" y="15" width="16" height="10" stroke="rgba(255,255,255,0.15)" strokeWidth="0.5" />
                    {/* Chart area */}
                    <polyline points="5,48 15,42 25,44 35,38 45,40 55,34 65,36 75,30" stroke="#3B82F6" strokeWidth="1" fill="none" />
                    <polyline points="5,50 15,46 25,48 35,43 45,45 55,40 65,42 75,38" stroke="#059669" strokeWidth="1" fill="none" opacity="0.6" />
                </svg>
            </div>
        );
    }

    return (
        <div className={`border border-neutral-700 bg-neutral-900/80 ${className}`}>
            {/* Browser chrome */}
            <div className="flex items-center gap-2 px-4 py-2 border-b border-neutral-700 bg-neutral-900">
                <div className="flex gap-1.5">
                    <div className="w-2.5 h-2.5 rounded-full bg-neutral-600" />
                    <div className="w-2.5 h-2.5 rounded-full bg-neutral-600" />
                    <div className="w-2.5 h-2.5 rounded-full bg-neutral-600" />
                </div>
                <div className="flex-1 mx-4">
                    <div className="bg-neutral-800 h-5 flex items-center px-3 text-[10px] text-gray-500 font-mono">
                        app.cgmsports.com/dashboard
                    </div>
                </div>
            </div>

            {/* Dashboard content */}
            <div className="p-4 space-y-4">
                {/* Header */}
                <div className="flex items-center justify-between">
                    <div>
                        <div className="text-xs text-gray-500 mb-0.5">Today's Overview</div>
                        <div className="text-sm font-bold text-white">Team Readiness</div>
                    </div>
                    <div className="text-[10px] text-gray-500 border border-neutral-700 px-2 py-0.5">
                        Live
                    </div>
                </div>

                {/* Stat cards row */}
                <div className="grid grid-cols-4 gap-2">
                    {stats.map((stat) => (
                        <div key={stat.label} className="border border-neutral-700 p-2">
                            <div className="text-[10px] text-gray-500">{stat.label}</div>
                            <div className="text-lg font-bold" style={{ color: stat.color }}>
                                {stat.value}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Chart area */}
                <div className="border border-neutral-700 p-3">
                    <div className="flex items-center gap-4 mb-2">
                        <div className="flex items-center gap-1">
                            <div className="w-2 h-2 bg-[#3B82F6]" />
                            <span className="text-[10px] text-gray-400">HRV</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <div className="w-2 h-2 bg-[#059669]" />
                            <span className="text-[10px] text-gray-400">Recovery</span>
                        </div>
                    </div>
                    <MockReadinessChart variant="compact" />
                </div>
            </div>
        </div>
    );
};

export default MockDashboardPreview;
